import { render, staticRenderFns } from "./EditEmergencyContact.vue?vue&type=template&id=344196a6&scoped=true"
import script from "./EditEmergencyContact.vue?vue&type=script&lang=js"
export * from "./EditEmergencyContact.vue?vue&type=script&lang=js"
import style0 from "./EditEmergencyContact.vue?vue&type=style&index=0&id=344196a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344196a6",
  null
  
)

export default component.exports